module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout.84c0fbae.png";